import React, {Suspense} from 'react';
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import PageLayout from "@view/layout/pageLayout/PageLayout";
import {MapGeoZonesLazy} from "@containers/map/containers/geoZones/MapGeoZones.lazy";


const GeoZonesMapPage = () => {
    return (
        <PageLayout>
            <Suspense
                fallback={<SpinnerCustom/>}
            >
                <MapGeoZonesLazy/>
            </Suspense>
        </PageLayout>
    );
};

export default GeoZonesMapPage;